<template>
  <modal
    class="finance-popup-container"
    name="finance-popup"
    :width="`90%`"
    :max-width="910"
    :height="`auto`"
    :scrollable="true"
    :adaptive="true"
    :shiftY="0.254"
    classes="finance-popup"
    @before-open="setInitialValues"
  >
    <div class="modal-wrap">
      <div class="title">
        <h1>FINANCE CALCULATOR</h1>
        <button class="close" @click="close"></button>
      </div>
      <div class="lg:flex lg:justify-between fin-content">
        <div class="left flex flex-col space-y-[30px]">
          <div class="form-field">
            <label>AMOUNT TO FINANCE ($)</label>
            <Cleave v-model="amountWithPrefix" :options="cleaveOptions" class="form-control"></Cleave>
            <!-- <input type="text" v-model="amount" @input="inputChange" /> -->
          </div>
          <div class="finance-field">
            <h3>INDICATIVE INTEREST RATE (%)</h3>
            <p v-show="! editingInterestRate" class="big-percent">
              {{ percentage }}%
            </p>
            <input
              type="text"
              v-show="editingInterestRate"
              v-model="percentage"
              @input="inputChange"
            />
            <p>{{ indicativeInterestRate }}</p>
            <a
              class="cursor-pointer red-click"
              @click="editingInterestRate = !editingInterestRate"
            >EDIT INTEREST RATE</a>
          </div>
          <div class="form-field">
            <div class="flex justify-between">
              <label>DEPOSIT ($)</label>
              <span>(OPTIONAL)</span>
            </div>
            <Cleave v-model="depositWithPrefix" :options="cleaveOptions"></Cleave>
          </div>
          <div class="finance-field">
            <h3>LOAN TERM (YEARS)</h3>
            <div class="range-slider-wrap">
              <multi-range-slider
                :baseClassName="`multi-range-slider-bar-only year-slider`"
                :min="1"
                :max="5"
                :step="1"
                :ruler="true"
                :label="false"
                :minValue="loanFrom"
                :rangeMargin="0"
                :maxValue="loanTo"
                v-model="term"
                @input="inputChange"
              />
              <div class="flex items-center slider-ruler">
                <div class="justify-start w-1/5 pl-2">
                  <span>1</span>
                </div>
                <div class="justify-start w-1/5 pl-4">
                  <span>2</span>
                </div>
                <div class="justify-start w-1/5 pl-6">
                  <span>3</span>
                </div>
                <div class="justify-start w-1/5 pl-8">
                  <span>4</span>
                </div>
                <div class="justify-start w-1/5 pl-10">
                  <span>5</span>
                </div>
              </div>
            </div>
          </div>
          <div class="finance-field">
            <h3>REPAYMENT FREQUENCY</h3>
            <div class="flex mt-5 space-x-2 repayment-btns">
              <a
                v-for="frequency in repaymentFrequencies"
                class="cursor-pointer tab-btn"
                :class="{ active: frequency === repaymentFrequency }"
                @click="repaymentFrequency = frequency"
              >{{ frequency }}</a>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="divide-y calc-area divide-zinc-300">
            <div class="top">
              <div class="flex items-center justify-between calc-row">
                <p class="est-title">ESTIMATED {{ repaymentFrequency }} REPAYMENTS</p>
                <p class="est-amount">{{ periodicPayments | currency }}</p>
              </div>
            </div>
            <div class="mid space-y-3.5">
              <div class="flex items-center justify-between calc-row">
                <p>Amount to Finance</p>
                <p>{{ amount | currency }}</p>
              </div>
              <div class="flex items-center justify-between calc-row">
                <p>Deposit Amount</p>
                <p>{{ deposit | currency }}</p>
              </div>
              <div class="flex items-center justify-between calc-row">
                <p>Total Interest paid at {{ percentage }}%</p>
                <p>{{ totalInterest | currency }}</p>
              </div>
              <div class="flex items-center justify-between calc-row">
                <p>Length of Loan</p>
                <p>{{ numberOfYears }} years</p>
              </div>
            </div>
            <div class="bottom">
              <div class="flex items-center justify-between calc-row">
                <p>Total Paid over {{ numberOfYears }} years</p>
                <p class="total-amount">{{ grandTotal | currency }}</p>
              </div>
              <div class="flex justify-end btn-wrap">
                <!-- <a v-if="data.mailTo" v-bind:href="'mailto:'+data.mailTo+'?subject=Finance Enquiry&body=Amount to Finance: '+amount+' %0D%0A%0D%0A Deposit Amount: '" class="button" >ENQUIRE NOW</a> -->
                <a v-if="data.mailTo" :href="'mailto:'+data.mailTo+'?subject=Finance Enquiry&body=I am enquiring about Listing URL%0D%0A '+url+' %0D%0A%0D%0A Boat Name: '+title+' %0D%0A Amount to Finance: '+currency(amount)+' %0D%0A Deposit Amount: '+currency(deposit)+' %0D%0A Total Interest paid at '+percentage+'%: '+currency(totalInterest)+' %0D%0A Length of Loan: '+numberOfYears+' years %0D%0A Estimated '+repaymentFrequency+' Repayments: '+currency(periodicPayments)+' %0D%0A Total Paid over '+numberOfYears+' years: '+currency(grandTotal)+'%0D%0A%0D%0A'" class="button" >ENQUIRE NOW</a>
                <a v-else href="#" class="button" @click="$root.showEnquirePopup(title)">ENQUIRE NOW</a>
              </div>
            </div>
          </div>
          <p class="footnote">
            {{ financeCalculatorMessage }}
          </p>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Cleave from 'vue-cleave-component'

export default {
  components: {
    Cleave,
  },

  props: {
    interestrate: {
      type : Number,
      default : 9.95
    },
    data: {
      type : Object,
      default: []
    }
  },

  filters: {
    currency (value) {
      if (! value) {
        return '0'
      }
      return (new Intl.NumberFormat('en-NZ', {
        style: 'currency',
        currency: 'NZD',
      })).format(value)
    },
  },

  data() {
    return {
      isOpen: false,
      url: window.location.href,
      amountWithPrefix: '0',
      depositWithPrefix: '0',
      loanFrom: 1,
      loanTo: 2,
      numberOfYears: 2,
      term: null,
      percentage: 9.95,
      financeCalculatorMessage: '',
      indicativeInterestRate: '',
      repaymentFrequency: 'WEEKLY',
      repaymentFrequencies: [
        'WEEKLY', 'FORTNIGHTLY', 'MONTHLY', 'ANNUALLY'
      ],
      editingInterestRate: false,
      cleaveOptions: {
        prefix: '$',
        numeral: true,
      },
      title: '',
    }
  },

  computed: {
    amount () {
      return this.amountWithPrefix.replace('$', '')
    },

    amountToLoan () {
      return this.amount - this.deposit
    },

    deposit () {
      return this.depositWithPrefix.replace('$', '')
    },

    periodicPayments () {
      const interest = this.interest
      let x = Math.pow(1 + interest, this.totalNumPayments)
      return (this.amountToLoan * x * interest) / (x - 1)
    },

    interest () {
      return this.percentage / 100 / this.numPeriodsPerYear
    },

    totalInterest () {
      if (! this.periodicPayments) {
        return 0
      }
      return (this.periodicPayments * this.totalNumPayments) - this.amountToLoan
    },

    grandTotal () {
      return parseFloat(this.deposit) + (this.periodicPayments * this.totalNumPayments)
    },

    numPeriodsPerYear () {
      return {
        WEEKLY: 52,
        FORTNIGHTLY: 26,
        MONTHLY: 12,
        ANNUALLY: 1,
      }[this.repaymentFrequency]
    },

    totalNumPayments () {
      return parseFloat(this.numberOfYears) * this.numPeriodsPerYear
    },
  },

  watch: {
    'term.minValue' (newValue) {
      if (newValue > 1) {
        this.term.minValue = 1
      }
    },
  },

  mounted () {
    this.financeCalculatorMessage = this.$attrs.financecontent
    this.indicativeInterestRate = this.$attrs.interestcontent
    this.percentage = this.interestrate
    // this.financeCalculatorMessage = window.financeCalculatorMessage
    // this.indicativeInterestRate = window.indicativeInterestRate
    if (this.isOpen) this.$modal.show('finance-popup')
  },

  methods: {
    currency (value) {
      if (! value) {
        return '0'
      }
      return (new Intl.NumberFormat('en-NZ', {
        style: 'currency',
        currency: 'NZD',
      })).format(value)
    },
    setInitialValues (event) {
      const amountToFinance = event.params.amountToFinance
      this.title = event.params.title

      if (amountToFinance) {
        this.amountWithPrefix = amountToFinance
        this.depositWithPrefix = '$' + (amountToFinance.replace(/[^0-9]/g, "") * 0.3)
      }
    },

    inputChange (e) {
      if (this.term) {
        this.numberOfYears = (this.term.maxValue - this.term.minValue) + 1
      }

      if (Number.isNaN(Number(this.amount))) {
        this.amount = this.amount.replace(/[^0-9]/g, "");
      }

      if (Number.isNaN(Number(this.deposit))) {
        this.deposit = this.deposit.replace(/[^0-9]/g, "");
      }
    },

    close () {
      this.$modal.hide('finance-popup')
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-wrap {
  height: calc(100vh - 100px);
  overflow-y: auto;
  overflow-x: hidden;

  @media (min-width: 1024px) {
    height: auto;
  }

  h1,
  h3,
  p,
  a,
  label {
    margin: 0;
    padding: 0;
  }

  .tab-btn {
    font-size: 10px;
  }

  .title {
    padding: 32px 30px 30px;
    border-bottom: 1px solid #d9d9d9;

    h1 {
      font-size: 18px;
      font-weight: 600;
      letter-spacing: 3px;
      line-height: 24px;
    }

    .close {
      position: absolute;
      top: 37px;
      right: 30px;

      width: 12px;
      height: 12px;

      background: url('/images/close-ico.png') no-repeat center center;
    }
  }

  .fin-content {
    padding: 30px 30px 40px;

    .form-field {
      padding: 0;

      label {
        margin-bottom: 10px;

        & + span {
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 1.7px;
          line-height: 18px;

          color: #9b9b9b;
        }
      }
    }

    .left,
    .right {
      width: 100%;

      @media (min-width: 1024px) {
        max-width: 410px;
      }
    }

    .left {
      .fin-section {
        margin-top: 30px;
      }

      .finance-field {
        h3 {
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 1.7px;
          line-height: 18px;

          color: #222428;
        }

        p {
          max-width: 300px;

          font-size: 12px;
          letter-spacing: 0.2px;
          line-height: 16px;

          color: #222428;

          &.big-percent {
            margin: 2px 0 10px;

            font-size: 24px;
            font-weight: 600;
            letter-spacing: 4px;
            line-height: 32px;
          }
        }

        .red-click {
          display: block;
          margin-top: 10px;

          font-size: 11px;
          font-weight: 600;
          letter-spacing: 1.7px;
          line-height: 14px;

          color: #ed1e23;
        }

        .range-slider-wrap {
          max-width: 300px;
          width: 100%;
          margin-top: 20px;

          .year-slider {
            ::v-deep .bar {
              height: 6px;

              .bar-left {
                padding: 0;
              }

              .bar-left,
              .bar-right {
                box-shadow: none;
                background-color: #f4f5f6;
              }

              .thumb-left {
                pointer-events: none;
                right: 5px;
              }

              .thumb-right {
                left: -5px;
              }

              .bar-inner {
                background-color: #ed1e23;
                box-shadow: none;
                border: none;
                pointer-events: none;
              }

              .thumb::before {
                border: none;
                background-color: #fff;
                box-shadow: none;
                border: 1px solid #ed1e23;
              }

              .caption {
                display: none;
              }
            }

            // ::v-deep .ruler {
            //   display: flex;

            //   .ruler-rule {
            //     display: flex;
            //   }
            // }
          }

          .slider-ruler {
            margin-top: 8px;

            span {
              font-size: 13.5px;
              letter-spacing: 0.3px;
              line-height: 18px;
              text-align: center;
            }
          }
        }

        .repayment-btns {
          overflow-y: auto;
        }
      }
    }

    .right {
      margin: 20px 0 0;

      @media (min-width: 1024px) {
        margin: 0;
      }

      .calc-area {
        margin-bottom: 33px;
        padding: 30px 20px;
        background-color: #f4f5f6;

        p {
          font-size: 13.5px;
          letter-spacing: 0.3px;
          line-height: 18px;

          color: #222428;
        }

        .top {
          .est-title {
            font-size: 15px;
            letter-spacing: 0.3px;
            line-height: 22px;
          }

          .est-amount {
            font-size: 24px;
            font-weight: 600;
            letter-spacing: 0.5px;
            line-height: 32px;
            text-align: right;
          }
        }

        .mid {
          margin-top: 30px;
          padding-top: 20px;
        }

        .bottom {
          margin-top: 20px;
          padding-top: 30px;

          .total-amount {
            font-size: 20px;
            letter-spacing: 0.42px;
            line-height: 32px;
            text-align: right;
          }

          .btn-wrap {
            margin-top: 20px;

            .button {
              width: 175px;
              height: 58px;

              font-size: 11px;
              font-weight: 600;
              letter-spacing: 1.7px;
              line-height: 14px;

              color: #fff;
              background-color: #ed1e23;
            }
          }
        }
      }

      .footnote {
        font-size: 12px;
        letter-spacing: 0.2px;
        line-height: 16px;
      }
    }
  }
}
</style>
